<template>
  <!-- O texto do item sai de `text` quando quem usa não diz outra chave: era o padrão do
       Vuetify 2, e as listas montadas no app ({value, text}) contam com ele. No Vuetify 4
       o padrão virou `title`. -->
  <v-select v-bind="$attrs" :items="items" :item-title="itemText || 'text'" :item-value="itemValue || itemText">
    <!-- No Vuetify 4 o slot desenha o item inteiro: sem o v-bind="props" ele não seleciona -->
    <template #item="{ item, props }">
      <v-list-item v-bind="props">
        <template #prepend v-if="items.some(i => i.icon)">
          <v-icon>{{ item.icon }}</v-icon>
        </template>
      </v-list-item>
    </template
    ><template #selection="{item}">
      <v-row no-gutters align="center">
        <v-col cols="auto" class="pr-2" v-if="item.icon">
          <v-icon> {{ item.icon }}</v-icon>
        </v-col>
        <v-col>
          {{ itemText ? item[itemText] : item.text }}
        </v-col>
      </v-row>
    </template></v-select
  >
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

@Component
class Select extends Vue {
  @Prop({type: String}) readonly itemText!: string
  @Prop({type: String}) readonly itemValue!: string
  @Prop({type: Array}) readonly items!: any[]


  name = 'ontos-select'
}

export default toNative(Select)
</script>
